import { render, staticRenderFns } from "./TopLeftQuadrangle.vue?vue&type=template&id=7d74ee22&"
import script from "./TopLeftQuadrangle.vue?vue&type=script&lang=js&"
export * from "./TopLeftQuadrangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports